import React from "react";
import { slugify } from '../../../../../utils/string_util';

export const ListNav = ({
  links = [],
  activeId,
  logo,
  className,
  titleClassName,
  title,
}) => {
  const hasLogo = logo?.icon || logo?.src;
  const logoHeight = 22;
  const logoWidth = 22;

  return (
    <nav className={`list-nav-container ${className || ""}`}>
      <div className="list-nav-inner"> 
          <div className="list-nav-content">
            <div className="list-nav-logo-section">
              {logo?.src && !logo?.icon && (
                <img
                  src={logo.src}
                  width={logoWidth}
                  height={logoHeight}
                  style={{ height: logoHeight, width: logoWidth }}
                  className="logo-image"
                  alt={logo.alt || "Franchise Logo"}
                />
              )}
              {title && (
                <div
                  className={`list-nav-title ${titleClassName || ""} ${
                    hasLogo ? "has-logo-margin" : ""
                  }`}
                >
                  {title}
                </div>
              )}
            </div>

            {links.map((link) => (
              <a
                key={slugify(link.id)}
                href={link.link}
                className={`list-nav-link ${
                  activeId === slugify(link.id) ? "is-active" : ""
                }`}
              >
                {link.label}
              </a>
            ))}
          </div>
      </div>
    </nav>
  );
};